//import { useDrawerContext } from "../../context/drawerContext";
import { useParams } from "react-router-dom";
import { useHeaderContext } from "../../context/headerContext";
import { useEffect, useState } from "react";
import Step1 from "./steps/step1";
import Step2 from "./steps/step2";
import Step3 from "./steps/step3";
import Step4 from "./steps/step4";
import Step5 from "./steps/step5";
import { useLocation } from "react-router-dom";

export default function AddBand() {
  const { step } = useParams();
  const { state } = useLocation();
  const { band, profile, emergencyContacts, medicalHistory, allergies, medications } = state;
  const { setTitle, setBackButton } = useHeaderContext();

  useEffect(() => {
    setTitle("Activate Band");
    setBackButton(true);
    localStorage.removeItem("activeGuestBandStep1");
    localStorage.removeItem("activeGuestBandStep2");
    localStorage.removeItem("activeGuestBandStep3");
    localStorage.removeItem("activeGuestBandStep4");
  }, []);
  
  let content;
  if (step >= 1 && step <= 5) {
    // Render specific screens based on step value
    switch (step) {
      case "1":
        content = <Step1 band={band} emergencyContacts={emergencyContacts} medicalHistory={medicalHistory} allergies={allergies} medications={medications} />;
        break;
      case "2":
        content = <Step2 band={band} profile={profile} emergencyContacts={emergencyContacts} medicalHistory={medicalHistory} allergies={allergies} medications={medications} />;
        break;
      case "3":
        content = <Step3 band={band} profile={profile} medicalHistory={medicalHistory} allergies={allergies} medications={medications} />;
        break;
      case "4":
        content = <Step4 band={band} profile={profile} allergies={allergies} medications={medications} />;
        break;
      case "5":
        content = <Step5 band={band} profile={profile} medications={medications}/>;
        break;
      default:
        content = <Step1 band={band} />;
        break;
    }
  } else {
    // Render 404 page for invalid step value
    throw Error;
  }

  return <>{content}</>;
}
